import {
  InteractionRequiredAuthError,
  BrowserAuthError,
} from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { Appeal } from '@scts/models';
import { acquireAccessToken } from '../contexts/auth/acquire-token';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

export const useAppeals = (apiUrl: string, theScopes: string[]) => {
  const [theToken, setTheToken] = useState('');
  const { instance, accounts } = useMsal();

  //REFACTOR THIS OUT OF HERE
  useEffect(() => {
    acquireAccessToken(instance, accounts[0], theScopes)
      .then((res) => {
        if (res.accessToken !== '') {
          setTheToken(res.accessToken);
        } else {
          setTheToken('invalid'); //api won't fire and therefore not return so stuck waiting if we don't set to something
        }
      })
      .catch((error) => {
        if (
          error instanceof InteractionRequiredAuthError ||
          error instanceof BrowserAuthError
        ) {
          const logoutRequest = {
            account: instance.getAllAccounts()[0],
            scopes: [theScopes],
          };
          instance.logoutRedirect(logoutRequest);
        }
      });
  }, []);

  const fetchData = async () => {
    const hdr = {
      headers: {
        Authorization: `Bearer ${theToken}`,
      },
    };

    const { data } = await axios.get(`${apiUrl}appeals`, hdr);
    return data;
  };

  return useQuery<Appeal[], Error>(['appeals', theToken], fetchData, {
    enabled: !!theToken,
  });
};
